<div>
  <label>Connect Live Stream</label>
  <select
    #type
    class="form-control"
    style="width: 200px; display: inline-block; margin-left: 8px"
    (change)="liveStreamTypeChanged($event.target.value)"
  >
    <option value=""></option>
    <option value="medialive">MediaLive</option>
    <option value="mux">Mux</option>
    <option value="ovenmediaengine">OvenMediaEngine</option>
  </select>
  <select
    #server
    class="form-control"
    style="width: 300px; display: inline-block; margin-left: 8px"
    [hidden]="!requiresServerSelection(type.value)"
    [disabled]="
      mediaServers.length === 0 || !requiresServerSelection(type.value)
    "
    (change)="serverChanged(type.value, $event.target.value)"
  >
    <option value=""></option>
    <option *ngFor="let server of mediaServers" [value]="server">{{
      server
    }}</option>
  </select>
  <select
    #app
    class="form-control"
    style="width: 150px; display: inline-block; margin-left: 8px"
    [hidden]="!requiresServerSelection(type.value)"
    [disabled]="
      !requiresServerSelection(type.value) ||
      !server.value ||
      mediaServers.length === 0
    "
    (change)="listLiveStreams(type.value, server.value, app.value)"
  >
    <option value=""></option>
    <option *ngFor="let app of apps" [value]="app">{{ app }}</option>
  </select>

  <select
    class="form-control ml-3"
    style="width: 300px; display: inline-block"
    [disabled]="!liveStreams?.length"
    (change)="liveStreamSelected($event.target.value)"
  >
    <option value=""></option>
    <option *ngFor="let l of liveStreams" [value]="l.streamId">
      {{ l.name || l.streamId }}
    </option>
  </select>

  <button
    mat-flat-button
    (click)="listLiveStreams(type.value, server.value, app.value)"
    >Refresh</button
  >
</div>
